import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import { RichText } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { Item } from '../PracticalInformation/Item'

export function SkiMaterial() {
  const ski = useCMSPageField('PDP.SkiAncillaries')
  const intl = useIntl()

  const introduction = ski?.skiMaterial?.introduction
  const extraInfo = ski?.skiMaterial?.extraInfo

  if (!introduction && !extraInfo)
    return null

  return (
    <Item elementDL="Ski material" title={intl.formatMessage({ id: 'ski_ancillaries_ski_material_title' })} Glyph="Skis">
      {introduction && <RichText innerHTML={introduction} />}
      {extraInfo && <RichText innerHTML={extraInfo} />}
    </Item>
  )
}
